import React from "react";
import Modal from "./Modal";
import Button from "../Button";
import Icon from "../Icon";
import { useNavigate } from "react-router-dom";

const AddServicesandPricingSuccessModal = ({
  setShowAcceptedModal,
  showAcceptedModal,
  businesName = "",
}) => {
  const navigate = useNavigate();
  return (
    <Modal
      show={showAcceptedModal}
      containerClassName={`success-modal`}
      hideClose={true}
    >
      <span>
        <Icon id={"checkSuccess"} height={"64"} width={"64"} />
      </span>
      <h4 className="mt-4 tx-c font-bold">
        Service Details Saved Successfully
      </h4>
      <p className="mt-2 co-gray tx-c ">
        You have successfully set up your contract with {businesName}. We'll let
        you know when the business approves it.
      </p>

      <Button
        variant="primary"
        type="submit"
        className="mt-4"
        block
        size={"md"}
        onClick={() => {
          navigate("/");
          setShowAcceptedModal(false);
        }}
      >
        {"Go to Dashboard"}
      </Button>
    </Modal>
  );
};

export default AddServicesandPricingSuccessModal;
